



























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteMotivosCancelamentoStore from '@/components/Suporte/Store/SuporteMotivosCancelamentoStore'

@Component
export default class ComponentModalSuporteMotivoCancelamento extends Vue {
  loadSaveOrUpdateMotivoCancelamento: boolean = false

  get getSuporteMotivosCancelamentoStore() {
    return getModule(SuporteMotivosCancelamentoStore, this.$store)
  }

  get loadingSaveOrUpdateMotivoCancelamento() {
    return this.loadSaveOrUpdateMotivoCancelamento
  }

  set loadingSaveOrUpdateMotivoCancelamento(value: boolean) {
    this.loadSaveOrUpdateMotivoCancelamento = value
  }

  get showModalMotivoCancelamento() {
    return this.getSuporteMotivosCancelamentoStore.modal.motivoCancelamento
  }

  set showModalMotivoCancelamento(value: boolean) {
    this.getSuporteMotivosCancelamentoStore.setModal({ name: 'motivoCancelamento', value })
  }

  $refs!: {
    formMotivoCancelemento: any
  }

  formMotivoCancelamentoRules: any = {
    valid: true,
    descricao: [(v: any) => !!v || 'Campo obrigatório.'],
    status: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  async saveOrUpdateMotivoCancelamento() {
    this.loadingSaveOrUpdateMotivoCancelamento = true

    if (this.$refs.formMotivoCancelemento.validate()) {
      const { mode } = this.getSuporteMotivosCancelamentoStore

      const response = await this.getSuporteMotivosCancelamentoStore.upsertMotivoCancelamentoByHospital()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Motivo ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuporteMotivosCancelamentoStore.getMotivosCancelamentoByHospitalId()
        this.showModalMotivoCancelamento = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o motivo ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateMotivoCancelamento = false
  }

  @Watch('showModalMotivoCancelamento')
  onChangeshowModalMotivoCancelamento(value: boolean) {
    if (!value) {
      this.getSuporteMotivosCancelamentoStore.clearMotivoCancelamento()
      this.getSuporteMotivosCancelamentoStore.setMode({ mode: 'CREATE' })
      this.$refs.formMotivoCancelemento.resetValidation()
    }
  }
}
